export const HOME_PATH = "/home";
export const GROUPS_PATH = "/groups";

export const HOME_START_PATH = `${HOME_PATH}`;
export const HOME_STATS_PATH = `${HOME_PATH}/stats`;
export const HOME_NEWS_PATH = `${HOME_PATH}/news`;
export const HOME_YOUTUBE_PATH = `${HOME_PATH}/youtube`;
export const HOME_ACADEMY_PATH = `${HOME_PATH}/academy`;

export const USERS_PATH = "/users";
export const COURSES_PATH = "/courses";
export const COURSES_CUSTOM_PATH = `${COURSES_PATH}/custom`;
// The course page is /courses/$type/$publicCourseUuid. A bare /courses/<uuid>
// matches /courses/$type instead and shows the custom courses list.
export const coursePagePath = (course: {
  Native: boolean;
  PublicUUID: string;
}) =>
  `${COURSES_PATH}/${course.Native ? "native" : "custom"}/${course.PublicUUID}`;
export const SIMULATORS_PATH = "/simulators";
export const SUPPORT_PATH = "/support";
export const INSTALLATION_GUIDE_PATH = `${SUPPORT_PATH}/installation`;

export const ADMIN_PATH = "/admin";
export const ADMIN_TICKET_BASE_PATH = `${ADMIN_PATH}/tickets`;
export const ADMIN_STATS_PATH = `${ADMIN_PATH}/stats`;
export const ADMIN_ALL_SIMULATORS_PATH = `${ADMIN_PATH}/simulators`;
export const ADMIN_ORGANIZATIONS_PATH = `${ADMIN_PATH}/organizations`;
export const ADMIN_SCHOOLS_PATH = `${ADMIN_PATH}/schools`;
export const ADMIN_ALL_USERS_PATH = `${ADMIN_PATH}/users`;
export const ADMIN_MAP_PATH = `${ADMIN_PATH}/map`;
export const ADMIN_TOPLIST_PATH = `${ADMIN_PATH}/toplist`;
export const ADMIN_COURSE_EDITOR_STATS_PATH = `${ADMIN_PATH}/course-editor-stats`;
export const ADMIN_RUNDATA_PATH = `${ADMIN_PATH}/rundata`;
export const ADMIN_EXERCISE_LEADERBOARD_PATH = `${ADMIN_PATH}/exercise-leaderboard`;
export const ADMIN_EXERCISE_COMMENTS_PATH = `${ADMIN_PATH}/exercise-comments`;
export const ADMIN_BILLING_PATH = `${ADMIN_PATH}/billing`;
export const ADMIN_COMPETITIONS_PATH = `${ADMIN_PATH}/competitions`;
export const ADMIN_ACADEMY_PATH = `${ADMIN_PATH}/academy`;
export const ADMIN_ACADEMY_COURSES = `${ADMIN_PATH}/courses`;

export const EDIT_LECTURE_BASEPATH = `${ADMIN_ACADEMY_COURSES}/edit`;
